const includesBotHeader = request => {
  const headerValue = request?.headers?.['akamai-bot'] || '';
  return /googlebot/gi.test(headerValue);
};

export default includesBotHeader;
